import { render, staticRenderFns } from "./tiscMessage.vue?vue&type=template&id=bd1367f0&scoped=true&"
import script from "./tiscMessage.vue?vue&type=script&lang=js&"
export * from "./tiscMessage.vue?vue&type=script&lang=js&"
import style0 from "./tiscMessage.vue?vue&type=style&index=0&id=bd1367f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1367f0",
  null
  
)

export default component.exports